import {
	GetDatasetByAuthorizedUserQuery,
	GetDatasetByAuthorizedUserQueryVariables,
} from "~dataset-view/types/__generated/gql/graphql";
import { graphierQLNextClient } from "~utils/api/graphierQLNextClient";

const query = /* GraphQL */ `
	query GetDatasetByAuthorizedUser($id: ID!) {
		getDatasetByAuthorizedUser(id: $id) {
			id
			createdAt
			updatedAt
			name
			description
			userId
			type
			datasourceType
			sourceDatasetId
			size
			mapsCount
			legendUrl
			getCapabilitiesUrl
			columns {
				name
				type
				subType
				width
				precision
				nullable
				uniqueConstraint
				defaultValue
				alias
				domainName
				comment
				timezone
			}
			bbox
			isSyncActive
			isAuthenticatedDropbox
			dropboxAccessToken
			dropboxFiles
			isPublic
			groupsAccesses {
				id
				viewable
				editable
			}
			_layers {
				id

				_layerGroup {
					id

					_map {
						id
						name
						description
					}
				}
			}
			_recordsCount
		}
	}
`;

export const getDatasetByAuthorizedUser = (
	variables: GetDatasetByAuthorizedUserQueryVariables,
) =>
	graphierQLNextClient<
		GetDatasetByAuthorizedUserQuery,
		GetDatasetByAuthorizedUserQueryVariables
	>({
		query,
		variables,
	}).then((res) => res.getDatasetByAuthorizedUser);
